import { Api, LogManager } from "@mcleod/core";
import { Layout } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";

const log = LogManager.getLogger("component-demo.dialogs.DemoErrorDialog");

export class DemoErrorDialog extends Layout {
    buttonServerErrorClicked() {
        Api.search("this/will/fail").then(response => log.info(response)).catch(err => CommonDialogs.showError(err));
    }
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoErrorDialog", [ "Dialogs", "Errors" ]));
